export const MENU_TYPE_OPTIONS = [
	{ value: '', label: 'None' },
	{ value: 'dashboard', label: 'Dashboard' },
	{ value: 'page', label: 'Page' },
]
